import { Directive } from '@angular/core';
import { IfCheckoutProcessDirective } from './if-checkout-process.directive';
@Directive({
    selector: '[ifNotCheckoutProcess]',
    standalone: true
})
export class IfNotCheckoutProcessDirective extends IfCheckoutProcessDirective {
    protected override check(): boolean {
        return !super.check();
    }
}
